import React, { useState, lazy, Suspense } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";

// Custom Loader Component
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const PropertyConfiguration = () => {
  const [activeTab, setActiveTab] = useState("propertyInfo");

  // Lazy load components
  const RoomTypes = lazy(() => import("../../pages/hms/components/RoomTypes"));
  const RoomMaster = lazy(() => import("../../pages/hms/components/RoomMaster"));
 // const RateCard = lazy(() => import("./components/RateCard"));
  const PropertyInfo = lazy(() => import("../../pages/hms/components/PropertyInfo"));
  //const PartnerCard = lazy(() => import("./components/Partners"));
  //const CorporateCompany = lazy(() => import("./components/CorporateCompany"));
  //const GeneralSettings = lazy(() => import("./components/GeneralSettings"));
  const UserManagement = lazy(() => import("../../pages/hms/components/ManageUsers"));
  const FrontTax = lazy(() => import("../../pages/hms/components/TaxManagement"));
 // const ExtraChargeCode = lazy(() => import("./components/ExtraChargeCode"));

  return (

      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h2>Property Configuration</h2>
            </div>
            <div className="col-md-6 float-end ms-auto">
              <div className="d-flex justify-content-end">
                {/* Add any buttons here if needed */}
              </div>
            </div>
          </div>
        </div>

        <div className="profile-bg-">
          <Tabs
            id="property-config-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-4"
          >
            <Tab eventKey="propertyInfo" title={<><i className="fas fa-building me-2"></i> Property Information</>}>
              <Suspense fallback={<LoadingSpinner />}>
                {activeTab === "propertyInfo" && <PropertyInfo />}
              </Suspense>
            </Tab>

            <Tab eventKey="roomTypes" title={<><i className="fas fa-bed me-2"></i> Room Types</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "roomTypes" && <RoomTypes />}
                </Suspense>
              </div>
            </Tab>

            <Tab eventKey="roomMaster" title={<><i className="fas fa-hotel me-2"></i> Room Master</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "roomMaster" && <RoomMaster />}
                </Suspense>
              </div>
            </Tab>


            <Tab eventKey="taxes" title={<><i className="fas fa-percent me-2"></i> Taxes</>}>
              <div className="card">
                <div className="card-body">

                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "taxes" && <FrontTax />}
                </Suspense>
 
                </div>
              </div>
            </Tab>
            






            




            <Tab eventKey="manageUsers" title={<><i className="fas fa-users me-2"></i> Manage Users</>}>
              <div className="card">
                <Suspense fallback={<LoadingSpinner />}>
                  {activeTab === "manageUsers" && <UserManagement />}
                </Suspense>
              </div>
            </Tab>
            
          </Tabs>
        </div>
      </div>
  
  );
};

export default PropertyConfiguration;